<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-input
        v-model="query.fName"
        placeholder="区域名称"
        size="small"
        style="width: 200px"
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="fName" label="区域名称" />
        <el-table-column prop="director" label="区域负责人" />
        <el-table-column prop="fDes" label="备注" />
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <el-button type="text" size="small" @click="_modify(scope.row)"
                >查看</el-button
              >
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import EditForm from "./EditForm";
import ConfirmButton from "@components/ConfirmButton";

export default {
  components: {
    EditForm,
    ConfirmButton,
  },
  data() {
    return {
      query: {
        fName: null,
      },
      tableData: [],
      loading: false,
      currentEditItem: null,
      canAdd: true,
    };
  },
  mounted() {
    this.refresh();

    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants;
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == "004006002") {
        this.canAdd = val.isGrant;
      }
    });
  },
  methods: {
    refresh() {
      this.loading = true;
      this.$httpPost(
        "BasicInformation/RegionDirector/RegionDirectorEntry",
        this.query
      )
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message);
            return;
          }

          this.tableData = res.datalist;
        })
        .finally(() => (this.loading = false));
    },
    _modify: async function (row) {
      this.currentEditItem = {
        regionID: row.fRegionID,
        regionName: row.fName,
      };
      const h = this.$createElement;
      this.$formDlg({
        title: "区域负责人编辑",
        formTpl: (
          <EditForm form={this.currentEditItem} canAdd={this.canAdd}></EditForm>
        ),
        width: "30%",
        formClose: () => this.refresh(),
        readonly: true,
      });
    },
    dateFormat: function (row, column, cellValue) {
      var date = cellValue;
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>
